<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <!-- Admin Yönetim Kartları -->
        <v-flex xs12>
          <v-card>
            <v-card-title class="primary white--text">
              <v-icon left color="white">dashboard</v-icon>
              Admin Dashboard
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-card class="mx-2 my-2" color="blue lighten-1" dark>
                    <v-card-title>
                      <v-icon left>people</v-icon>
                      Kullanıcı Yönetimi
                    </v-card-title>
                    <v-card-text>
                      Sistem kullanıcılarını görüntüleyin, düzenleyin ve yönetin.
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="$router.push('/admin/users')">
                        Git
                        <v-icon right>arrow_forward</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                
                <v-flex xs12 md6>
                  <v-card class="mx-2 my-2" color="green lighten-1" dark>
                    <v-card-title>
                      <v-icon left>business</v-icon>
                      Kullanıcı Tenants
                    </v-card-title>
                    <v-card-text>
                      Kullanıcı-tenant-marketplace ilişkilerini yönetin.
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="$router.push('/admin/user-tenants')">
                        Git
                        <v-icon right>arrow_forward</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        
        <!-- Sistem Bilgileri -->
        <v-flex xs12 mt-4>
          <v-card>
            <v-card-title>
              <v-icon left>info</v-icon>
              Sistem Bilgileri
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Toplam Kullanıcı</v-list-tile-title>
                        <v-list-tile-sub-title>{{ userCount }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 md4>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Toplam UserTenant</v-list-tile-title>
                        <v-list-tile-sub-title>{{ userTenantCount }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs12 md4>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Son Giriş</v-list-tile-title>
                        <v-list-tile-sub-title>{{ new Date().toLocaleString('tr-TR') }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userCount: 0,
      userTenantCount: 0
    };
  },
  async created() {
    await this.loadStats();
  },
  methods: {
    async loadStats() {
      try {
        const usersResponse = await fetch(`${process.env.VUE_APP_API}/api/users`, {
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        if (usersResponse.ok) {
          const users = await usersResponse.json();
          this.userCount = users.length;
        }
        
        const userTenantsResponse = await fetch(`${process.env.VUE_APP_API}/api/usertenants`, {
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        if (userTenantsResponse.ok) {
          const userTenants = await userTenantsResponse.json();
          this.userTenantCount = userTenants.length;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('İstatistikler yüklenirken hata:', error);
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  margin-bottom: 20px;
}
</style>

